import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_S3_6_12: TStep[] = [
  { pageId: PageId.DOG_BREED_S3_6_12 },
  { pageId: PageId.DOG_AGE_S3_6_12 },
  { pageId: PageId.SHELTER_S3_6_12 },
  { pageId: PageId.COMMANDS_S3_6_12 },
  { pageId: PageId.SUBSCRIPTIONS_S3_6_12 },
  { pageId: PageId.CHAT_UPSELL_S3_6_12 },
  { pageId: PageId.UPSELL_1_S3_6_12 },
  { pageId: PageId.ACCOUNT_NOVE8 },
  { pageId: PageId.DOWNLOAD_S3_6_12 },
]
